import axios from 'axios';

export const getInvoiceList = (
  status: number,
  receipt_issue_flg: number,
  construct_sub: string,
  sales_user_id: number,
  construct_code: string,
  billing_customer_name: string,
  issuance_from_date: string,
  issuance_end_date: string,
  payment_confirm_from_date: string,
  payment_confirm_end_date: string,
  billing_amount: number,
  payment_from_date: string,
  payment_end_date: string,
  delivery_method: number,
  prefecture_name: string,
  address: string,
  current_page: number,
  display_limit: number,
  sort_field: any,
  sort_direction: any
) => {
  return axios
    .get('/api/v1/invoices', {
      params: {
        status,
        receipt_issue_flg,
        construct_sub,
        sales_user_id,
        construct_code,
        billing_customer_name,
        issuance_from_date,
        issuance_end_date,
        payment_confirm_from_date,
        payment_confirm_end_date,
        billing_amount,
        payment_from_date,
        payment_end_date,
        delivery_method,
        prefecture_name,
        address,
        display_limit,
        sort_field,
        sort_direction,
        page: current_page
      },
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const getPaymentMethodList = () => {
  return axios
    .get(`/api/v1/get/delivery/methods/list`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const deleteInvoiceList = (invoices_list: any) => {
  return axios
    .post(
      `/api/v1/delete/invoices`,
      {
        invoices_list: invoices_list
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const deleteSingleInvoice = (id: number) => {
  return axios
    .delete(`/api/v1/invoices/${id}`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const getConstructEstimate = (
  id: number,
  sort_field?: string,
  sort_direction?: string
) => {
  return axios
    .get(`/api/v1/construct/estimates/${id}`, {
      headers: {
        withCredentials: true
      },
      params: {
        sort_field,
        sort_direction
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const getConstructId_by_client = (
  id: number,
  sort_field?: string,
  sort_direction?: string
) => {
  return axios
    .get(`/api/v1/constructions/client/${id}`, {
      headers: {
        withCredentials: true
      },
      params: {
        sort_field,
        sort_direction
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response && err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const checkInvoiceByEstimateId = (estimateId: number) => {
  return axios
    .get(`/api/v1/invoices/by_estimate/${estimateId}`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response && err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const getBillingCategory = () => {
  return axios
    .get(`/api/v1/get/billing/types/list`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const getDeliveryMethods = () => {
  return axios
    .get(`/api/v1/get/delivery/methods/list`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const createInvoices = (
  status: number,
  client_name: string,
  honorific_title: string,
  contractor_name: string,
  payment_date: string,
  payee: string,
  published_date: string,
  confirm_date: string,
  construct_id: number,
  construct_name: string,
  billing_user_id: number,
  sales_user_id: number,
  output_pdf: boolean,
  output_details: boolean,
  delivery_method_id: number,
  billing_type_id: number,
  free_field: string,
  contract_total: number,
  already_paid: number,
  billing_total: number,
  balance_total: number,
  tax_rule: number,
  remarks: string,
  memo: string,
  invoice_estimates: any,
  client_id: number,
  receipt_note: string
) => {
  return axios
    .post(
      `/api/v1/invoice/create`,
      {
        status,
        client_name,
        honorific_title,
        contractor_name,
        payment_date,
        payee,
        published_date,
        confirm_date,
        construct_id,
        construct_name,
        billing_user_id,
        sales_user_id,
        output_pdf,
        output_details,
        delivery_method_id,
        billing_type_id,
        free_field,
        contract_total,
        already_paid,
        billing_total,
        balance_total,
        tax_rule,
        remarks,
        memo,
        invoice_estimates,
        client_id,
        receipt_note
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const getInvoiceDetails = (id: number) => {
  return axios
    .get(`/api/v1/invoices/${id}`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const updateInvoices = (
  id: number,
  status: number,
  client_name: string,
  honorific_title: string,
  contractor_name: string,
  payment_date: string,
  payee: string,
  published_date: string,
  confirm_date: string,
  construct_id: number,
  construct_name: string,
  billing_user_id: number,
  sales_user_id: number,
  output_pdf: boolean,
  output_details: boolean,
  delivery_method_id: number,
  billing_type_id: number,
  free_field: string,
  contract_total: number,
  already_paid: number,
  billing_total: number,
  balance_total: number,
  tax_rule: number,
  remarks: string,
  memo: string,
  invoice_estimates: any,
  receipt_note: string
) => {
  return axios
    .put(
      `/api/v1/invoices/${id}`,
      {
        status,
        client_name,
        honorific_title,
        contractor_name,
        payment_date,
        payee,
        published_date,
        confirm_date,
        construct_id,
        construct_name,
        billing_user_id,
        sales_user_id,
        output_pdf,
        output_details,
        delivery_method_id,
        billing_type_id,
        free_field,
        contract_total,
        already_paid,
        billing_total,
        balance_total,
        tax_rule,
        remarks,
        memo,
        invoice_estimates,
        receipt_note
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const copyInvoices = (invoice_id: number, construct_id: number) => {
  return axios
    .post(
      `/api/v1/copy/invoices/${invoice_id}`,
      { construct_id },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const updateInvoiceStatus = (invoice_id: number, status: number) => {
  return axios
    .put(
      `/api/v1/invoices/${invoice_id}/status`,
      {
        status
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const updateInvoiceReceiptIssueStatus = (
  invoice_id: number,
  receipt_issue_flg: number
) => {
  return axios
    .put(
      `/api/v1/invoices/${invoice_id}/update_receipt_issue_flg`,
      {
        receipt_issue_flg
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const updatePaymentConfirmDate = (
  invoice_id: number,
  payment_confirm_date: Date | null
) => {
  return axios
    .put(
      `/api/v1/invoices/${invoice_id}/update_payment_confirm_date`,
      {
        payment_confirm_date
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};
export const updateInvoiceMemo = (invoice_id: number, memo: string) => {
  return axios
    .put(
      `/api/v1/invoices/${invoice_id}/memo`,
      {
        memo
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};
export const getExportInvoiceItems = (
  selected_columns: any,
  status: number,
  construct_sub: string,
  billing_customer_name: string,
  issuance_from_date: string,
  issuance_end_date: string,
  payment_confirm_from_date: string,
  payment_confirm_end_date: string,
  billing_amount: number,
  payment_from_date: string,
  payment_end_date: string,
  delivery_method: number,
  prefecture_name: string,
  address: string
) => {
  return axios
    .post(
      `/api/v1/export/invoices/list?status=${status}&construct_sub=${construct_sub}&billing_customer_name=${billing_customer_name}&issuance_from_date=${issuance_from_date}&issuance_end_date=${issuance_end_date}&payment_confirm_from_date=${payment_confirm_from_date}&payment_confirm_end_date=${payment_confirm_end_date}&billing_amount=${billing_amount}&payment_from_date=${payment_from_date}&payment_end_date=${payment_end_date}&delivery_method=${delivery_method}&prefecture_name=${prefecture_name}&address=${address}`,
      {
        selected_columns
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

/**
 * 請求アラートデータ取得
 */
export const getUnbilledAlertList = () => {
  return axios
    .get('/api/v1/invoice/get-unbilled-alert-list', {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

/**
 * 請求アラート対象外へ更新
 * @param selectList
 */
export const updateNotBillable = (selectList: number[]) => {
  return axios
    .post(
      `/api/v1/invoice/update-not-billable`,
      {
        selectList
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};
